var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.skuName"),
                          prop: "skuName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("goodsPage.skuName"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuName", $$v)
                            },
                            expression: "queryParams.skuName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.skuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("goodsPage.skuCode"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.categoryName"),
                          prop: "categoryIdList",
                        },
                      },
                      [
                        _c("BjGoodsTypeTreeSelect", {
                          attrs: {
                            placeholder: _vm.$t("goodsPage.categoryName"),
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.categoryIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "categoryIdList", $$v)
                            },
                            expression: "queryParams.categoryIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.setFlag != "draft"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("table.statusText") } },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.GOODS_SKU_STATUS_NORMAL,
                                placeholder: _vm.$t("table.statusText"),
                                "collapse-tags":
                                  _vm.tempStatus && _vm.tempStatus.length > 2,
                                multiple: "",
                              },
                              model: {
                                value: _vm.tempStatus,
                                callback: function ($$v) {
                                  _vm.tempStatus = $$v
                                },
                                expression: "tempStatus",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsSku.page.ExpirationStatus"),
                          prop: "expireStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_YES_NUM,
                            placeholder: _vm.$t(
                              "goodsSku.page.ExpirationStatus"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.expireStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "expireStatus", $$v)
                            },
                            expression: "queryParams.expireStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                  ? _c(
                      "el-col",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuOrdinary_ImportData",
                                arg: "BusinessGoodsSkuOrdinary_ImportData",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: { click: _vm.onCreate },
                          },
                          [_vm._v(_vm._s(_vm.$t("ExcelConfig.Title")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.queryParams.setFlag ==
                                  _vm.GOODS_COMBO_TYPES.ORDINARY,
                                expression:
                                  "queryParams.setFlag == GOODS_COMBO_TYPES.ORDINARY",
                              },
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuOrdinaryAdd",
                                arg: "BusinessGoodsSkuOrdinaryAdd",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("goodsSku.page.commonSKU")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.queryParams.setFlag ==
                                  _vm.GOODS_COMBO_TYPES.ORDINARY,
                                expression:
                                  "queryParams.setFlag == GOODS_COMBO_TYPES.ORDINARY",
                              },
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuOrdinaryAdd",
                                arg: "BusinessGoodsSkuOrdinaryAdd",
                              },
                            ],
                            attrs: {
                              disabled: tableOperationProp.notSelected,
                              type: "primary",
                            },
                            on: { click: _vm.pushStore },
                          },
                          [_vm._v("SKU推送")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuOrdinary_Audit",
                                arg: "BusinessGoodsSkuOrdinary_Audit",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              disabled: tableOperationProp.notSelected,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onAudit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("submitText")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE
                  ? _c(
                      "el-col",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.queryParams.setFlag ==
                                  _vm.GOODS_COMBO_TYPES.PACKAGE,
                                expression:
                                  "queryParams.setFlag == GOODS_COMBO_TYPES.PACKAGE",
                              },
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuPackageAdd",
                                arg: "BusinessGoodsSkuPackageAdd",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("goodsSku.page.packageSKU")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuPackage_Audit",
                                arg: "BusinessGoodsSkuPackage_Audit",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              disabled: tableOperationProp.notSelected,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onAudit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("submitText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onExport },
                          },
                          [_vm._v(_vm._s(_vm.$t("exportText")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.setFlag == "draft"
                  ? _c(
                      "el-col",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessGoodsSkuDraft_Audit",
                                arg: "BusinessGoodsSkuDraft_Audit",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: {
                              type: "primary",
                              disabled: tableOperationProp.notSelected,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onAudit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("submitText")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    (col.prop !== "bjTableAction" && col.prop !== "status") ||
                    (col.prop === "status" && _vm.setFlag !== "draft")
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "materialMainImages"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-spacebetween",
                                          },
                                          [
                                            _c("BjViewUrl", {
                                              attrs: {
                                                url: (scope.row[col.prop] ||
                                                  [])[0],
                                                height: "80px",
                                                preview: "",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : col.prop === "skuName"
                                      ? [
                                          _vm.setFlag ==
                                          _vm.GOODS_COMBO_TYPES.ORDINARY
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showSku(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[col.prop]
                                                      )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                [
                                                  _vm.setFlag == "draft" &&
                                                  scope.row.setFlag == 1
                                                    ? _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "goodsSku.page.Set"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[col.prop]
                                                      )
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      : col.prop === "licenseExpireDate" &&
                                        _vm.setFlag ==
                                          _vm.GOODS_COMBO_TYPES.ORDINARY
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              scope.row
                                                .licenseExpireDateStatus === 2
                                                ? "color:red"
                                                : scope.row
                                                    .licenseExpireDateStatus ===
                                                  1
                                                ? "color:#082dc3"
                                                : "",
                                          },
                                          [_vm._v(_vm._s(scope.row[col.prop]))]
                                        )
                                      : col.prop === "status"
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.GOODS_SKU_STATUS.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ) + " "
                                          ),
                                        ])
                                      : col.prop
                                          .toLocaleLowerCase()
                                          .includes("price")
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$number2money(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value:
                                              props.row.setFlag ==
                                              _vm.GOODS_COMBO_TYPES.ORDINARY
                                                ? "BusinessGoodsSkuOrdinaryView"
                                                : "BusinessGoodsSkuPackageView",
                                            expression:
                                              "\n                  props.row.setFlag == GOODS_COMBO_TYPES.ORDINARY\n                    ? 'BusinessGoodsSkuOrdinaryView'\n                    : 'BusinessGoodsSkuPackageView'\n                ",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value:
                                              props.row.setFlag ==
                                              _vm.GOODS_COMBO_TYPES.ORDINARY
                                                ? "BusinessGoodsSkuOrdinaryEdit"
                                                : "BusinessGoodsSkuPackageEdit",
                                            expression:
                                              "\n                  props.row.setFlag == GOODS_COMBO_TYPES.ORDINARY\n                    ? 'BusinessGoodsSkuOrdinaryEdit'\n                    : 'BusinessGoodsSkuPackageEdit'\n                ",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: {
                                          disabled:
                                            !_vm.CAN_EDIT_STATUS.includes(
                                              Number(props.row.status)
                                            ),
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _vm.setFlag == "draft"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: {
                                              disabled:
                                                !_vm.CAN_DELETE_STATUS.includes(
                                                  Number(props.row.status)
                                                ),
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("SkuRowData", { ref: "SkuRowData" }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        on: { submit: _vm.handleQuery },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }